import styled from "styled-components";
import { motion } from "framer-motion";

export const M_Container = styled(motion.div)`
	display: grid;

	grid-auto-flow: column;
	grid-auto-columns: 220px;
	gap: 10px;
	overflow: visible;
	padding-bottom: 4px; // чтобы скролл не прилипал
	/* красивый скролл (опционально) */
	scrollbar-width: thin;

	&::-webkit-scrollbar {
		height: 6px;
	}
`;

export const modulesVariants = {
	hidden: {},

	visible: {
		transition: {
			delayChildren: 0.12,
			staggerChildren: 0.1,
		},
	},
	exit: {},
};
